import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, Mail } from 'lucide-react';

export default function PendingApproval() {
    return (
        <div className="min-h-screen flex items-center justify-center p-8 bg-slate-50">
            <div className="w-full max-w-md">
                <div className="flex items-center justify-center gap-3 mb-8">
                    <img 
                        src="https://customer-assets.emergentagent.com/job_powermonitor-5/artifacts/rtabpwt5_Sem%20Fundo.png" 
                        alt="MedEletrões Logo" 
                        className="w-24 h-24 object-contain"
                    />
                    <div>
                        <h1 className="text-2xl font-bold font-heading text-slate-900">MedEletrões</h1>
                        <p className="text-sm text-slate-500">Gestão de Energia</p>
                    </div>
                </div>

                <Card className="border-0 shadow-xl text-center">
                    <CardHeader className="pb-4">
                        <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
                            <Clock className="w-8 h-8 text-amber-600" />
                        </div>
                        <CardTitle className="text-2xl font-bold font-heading">Conta Pendente</CardTitle>
                        <CardDescription>
                            A sua conta foi criada com sucesso
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                        <div className="p-4 rounded-lg bg-amber-50 text-amber-800 text-sm">
                            <div className="flex items-center justify-center gap-2 mb-2">
                                <Mail className="w-4 h-4" />
                                <span className="font-medium">Aguarda Aprovação</span>
                            </div>
                            <p>
                                O administrador da sua empresa irá aprovar a sua conta em breve.
                                Receberá uma notificação quando a conta estiver ativa.
                            </p>
                        </div>

                        <div className="space-y-3">
                            <p className="text-sm text-slate-500">
                                Depois de aprovado, poderá iniciar sessão normalmente.
                            </p>
                            <Button asChild variant="outline" className="w-full">
                                <Link to="/login">
                                    Voltar ao Login
                                </Link>
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
